/**
 * Єдиний кеш категорій за типом (business | personal | cash).
 * Уникає сотень паралельних GET /api/categories при таблиці з багатьма рядками.
 */

const resolved = new Map();
const inflight = new Map();

/** Викликається після invalidate — щоб відкриті селекти підтягнули актуальний список з БД. */
const invalidationListeners = new Set();

export function subscribeCategoriesInvalidation(listener) {
    invalidationListeners.add(listener);
    return () => invalidationListeners.delete(listener);
}

function notifyCategoriesInvalidated(type) {
    for (const fn of invalidationListeners) {
        try {
            fn(type);
        } catch {
            /* ignore */
        }
    }
}

/**
 * @param {string} type business | personal | cash
 * @param {{ bypassCache?: boolean }} [opts]
 */
export function fetchCategoriesCached(type, opts = {}) {
    const bypassCache = opts.bypassCache === true;

    if (!type) {
        return Promise.resolve([]);
    }

    if (bypassCache) {
        resolved.delete(type);
        inflight.delete(type);
    }

    if (resolved.has(type)) {
        return Promise.resolve(resolved.get(type));
    }
    if (inflight.has(type)) {
        return inflight.get(type);
    }

    const p = fetch(`/api/categories?type=${encodeURIComponent(type)}`, {
        credentials: "include",
    })
        .then((r) => r.json())
        .then((data) => {
            const rows = Array.isArray(data) ? data : [];
            resolved.set(type, rows);
            inflight.delete(type);
            return rows;
        })
        .catch(() => {
            inflight.delete(type);
            resolved.set(type, []);
            return [];
        });

    inflight.set(type, p);
    return p;
}

/** Після створення/редагування/видалення категорії — скинути кеш для цього типу (або весь). */
export function invalidateCategoriesCache(type) {
    if (type) {
        resolved.delete(type);
        inflight.delete(type);
    } else {
        resolved.clear();
        inflight.clear();
    }
    notifyCategoriesInvalidated(type);
}
